<template>
  <PageTemplate>
    <h1>Pending Approval</h1>
    <div>
      <v-card :title="user.first_name + ' ' + user.last_name">
        <template>
          <v-data-list :data="roles" />
          <div>
            <v-label text="CHANGE REQUEST IN" />
            <div
              v-for="(change,index) in currentRequest"
              :key="index"
            >
              <v-checkbox
                :id="index"
                @check="checkIn(index)"
              >
                <strong>{{ index.toUpperCase() }}</strong>
              </v-checkbox>
              <div class="row">
                <v-fieldset
                  class="col-md-4"
                  type="display"
                  text="From"
                  :value="user[index]"
                />
                <v-fieldset
                  class="col-md-4"
                  type="display"
                  text="To"
                  :value="change"
                />
              </div>
            </div>
          </div>
        </template>
        <v-button-group>
          <v-button
            size="lg"
            has-min-width
            :is-disabled="selectedChange.length === 0"
            @click="confirmationModal = true"
          >
            Approve
          </v-button>
          <v-button
            size="lg"
            color="danger"
            has-min-width
            :is-disabled="selectedChange.length === 0"
            @click="rejectionModal = true"
          >
            Reject
          </v-button>
        </v-button-group>
      </v-card>
      <v-button
        color="transparent"
        @click="$router.push('/admin/outstanding-activities')"
      >
        Cancel
      </v-button>
    </div>
    <v-modal
      v-if="confirmationModal"
      @close="closeModal"
    >
      <template #header>
        {{ isConfirmed ? 'Successful' : 'Confirmation' }}
      </template>
      <template v-if="isConfirmed">
        You have successfully approved
        {{ user.first_name }} {{ user.last_name }}’s request of changing his info
      </template>
      <template v-else>
        Are you sure you want to approve {{ user.first_name }} {{ user.last_name }}’s profile change?
      </template>
      <template #footer>
        <v-button-group is-right>
          <v-button
            v-if="!isConfirmed"
            size="lg"
            has-min-width
            @click="approve"
          >
            Yes, Approve
          </v-button>
          <v-button
            :color="isConfirmed ? 'primary' : 'secondary'"
            size="lg"
            has-min-width
            @click="closeModal"
          >
            {{ isConfirmed ? 'Got it' : 'Cancel' }}
          </v-button>
        </v-button-group>
      </template>
    </v-modal>
    <v-modal
      v-if="rejectionModal"
      @close="closeModal"
    >
      <template #header>
        Reject with a reason
        {{ isConfirmed ? 'Successful' : 'Confirmation' }}
      </template>
      <template v-if="rejectionReasonSubmitted && isConfirmed">
        You have successfully rejected
        {{ user.first_name }} {{ user.last_name }} 's profile changes request!
      </template>
      <template v-else-if="rejectionReasonSubmitted && !isConfirmed">
        You Rejected {{ user.first_name }} {{ user.last_name }}’s profile changes request with following reason: <br>
        {{ rejectionReason }}
        <br><br>
        Are you sure you want to continue?
      </template>
      <template v-else>
        <v-fieldset
          v-model="rejectionReason"
          type="textarea"
        />
      </template>
      <template #footer>
        <v-button-group is-right>
          <v-button
            v-if="rejectionReasonSubmitted && !isConfirmed"
            size="lg"
            has-min-width
            @click="reject"
          >
            Yes, continue
          </v-button>
          <v-button
            v-if="!rejectionReasonSubmitted"
            size="lg"
            color="danger"
            has-min-width
            :is-disabled="!rejectionReason"
            @click="rejectionReasonSubmitted = true"
          >
            Reject
          </v-button>
          <v-button
            :color="isConfirmed ? 'primary' : 'secondary'"
            size="lg"
            has-min-width
            @click="closeModal"
          >
            {{ isConfirmed ? 'Got it' : 'Cancel' }}
          </v-button>
        </v-button-group>
      </template>
    </v-modal>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "@/templates/Page";
  import Card from "@/molecules/Card";
  import Label from "@/atoms/Label";
  import Modal from "@/atoms/Modal";
  import Checkbox from "@/atoms/Checkbox";
  import Button from "@/atoms/Button";
  import DataList from "@/atoms/DataList";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import Fieldset from "@/molecules/Fieldset";
  import {buildBreadCrumb,buildDefinitionList} from "@/common/tableFunctions"
  import {
    APPROVE_USER_REQUEST,
    GET_USER_REQUEST
  } from "@/store/actions.type";
  import constants from "@/common/constants";
  import routes from "@/common/routes";
  import {mapState} from "vuex";

  export default {
    name: "Users",
    components: {
      "v-card": Card,
      "v-label":Label,
      "v-checkbox": Checkbox,
      "v-button-group": ButtonGroup,
      "v-button": Button,
      "v-data-list": DataList,
      "v-modal": Modal,
      "v-fieldset": Fieldset,
      PageTemplate
    },
    data: () => ({
      confirmationModal: false,
      rejectionModal: false,
      rejectionReason: '',
      rejectionReasonSubmitted: false,
      isConfirmed: false,
      selectedChange:[]
    }),
    computed: {
      ...mapState({
        users: state => state.userRequest.users,
        profileChanges: state => state.userRequest.profileChanges
      }),
      currentRequest: function(){
        let id = this.$route.params.id;
        return JSON.parse(this.profileChanges.filter(el => el.id == id)[0].value);
      },
      user: function(){
        let id = this.$route.params.id;
        return this.profileChanges.filter(el => el.id == id)[0].user;
      },
      roles: function(){
        let id = this.$route.params.id;
        let roles = [];
        roles['User Type'] = this.profileChanges.filter(el => el.id == id)[0].user.roles.map(function(val){
          return constants.USER_ROLES.find(f => f.name == val.name).fullName
        }).join(',');
        return buildDefinitionList(roles);
      }
    },
    mounted() {
      this.updateBreadCrumb();
      this.getUsersRequest();
    },
    methods: {
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Outstanding Activities'] = routes.ADMIN.OUTSTANDING_ACTIVITIES;
        breadcrumbs['All Pending Profile Change'] = routes.ADMIN.PENDING_PROFILE_CHANGE_ALL;
        breadcrumbs['Pending Approval'] = '';
        this.breadcrumbs = buildBreadCrumb(breadcrumbs);
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      getUsersRequest(){
        this.$store.dispatch(GET_USER_REQUEST);
      },
      closeModal: function () {
        this.confirmationModal = false;
        this.rejectionModal = false;
        this.rejectionReason = '';
        this.isConfirmed = false;
        this.$router.push(routes.ADMIN.OUTSTANDING_ACTIVITIES);
      },
      checkIn(index)
      {
        if(!this.selectedChange.includes(index))
        {
          this.selectedChange.push(index)
        }else{
          this.selectedChange.splice(this.selectedChange.findIndex(o => o == index), 1)
        }
      },
      approve(){
        let params = {};
        params.status = 'approve';
        params.type = 'update';
        params.data =  this.selectedChange;
        this.$store.dispatch(APPROVE_USER_REQUEST,[this.$route.params.id,params])
          .then(response => {
            this.$notify({
              title: 'Success',
              text: response.message,
              type: 'success'
            });
            this.isConfirmed = true;
          })
          .catch(error => {
            this.$notify({
              title: 'Error',
              text: 'Something went wrong.',
              type: 'error'
            });
          })
      },
      reject(){
        let params = {};
        params.status = 'reject';
        params.type = 'update';
        params.data =  this.selectedChange;
        params.reject_reason = this.rejectionReason;
        this.$store.dispatch(APPROVE_USER_REQUEST,[this.$route.params.id,params])
          .then(response => {
            this.$notify({
              title: 'Success',
              text: response.message,
              type: 'success'
            });
            this.isConfirmed = true;
          })
          .catch(error => {
            this.$notify({
              title: 'Error',
              text: 'Something went wrong.',
              type: 'error'
            });
          })
      }
    }
  }
</script>

